import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { ExtendAcceptanceInitFormResponseModel } from "src/app/model/ExtendAcceptanceInitFormResponseModel";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
import { Page } from "src/app/model/Page";
// import { ConsoleReporter } from "jasmine";
import { SopConfigListModel } from "src/app/model/SopConfigListModel";
import { SopConfigResponse } from "src/app/model/SopConfigResponse";
import { SopFormResponse } from "src/app/model/SopFormResponse";
import { TenementExchangeModel } from "src/app/model/TenementExchangeModel";
import { TenementModal } from "src/app/model/TenementModal";
import { ExtendAcceptanceService } from "src/app/services/extend-acceptance.Service";
import { InstallmentConfigService } from "src/app/services/installment-config.service";
import { MasterService } from "src/app/services/master.service";
import { ExtendedAcceptanceModalComponent } from "./extend-data-modal/extend-data-modal.component";
// import { ExtendedAcceptanceModalComponent } from "./extend-data-modal/extend-data-modal.component";

@Component({
  selector: "app-secure-extend-acceptance",
  templateUrl: "./extend-acceptance.component.html",
  styleUrls: ["./extend-acceptance.component.scss"],
})
export class ExtendedAcceptanceComponent implements OnInit {
  lotteryKey: number;
  schemeKey: number;
  pageMode: string;
  lotteryResponseModel: SopFormResponse;
  page: Page<ExtendAcceptanceInitFormResponseModel>;
  lotteryEventId: number;
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  drawStatus :string;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  isButtonVisible: boolean = false;
  isAnyCheckboxSelected: boolean = false;
  lotteryList: { [key: number]: string };
  schemes: { [key: number]: string };
  filterText:string;
  dataSource: MatTableDataSource<TenementModal> = new MatTableDataSource();
selectedElement: TenementModal[]=[];
isAllSelected: boolean = false;
selectedElements: TenementModal[] = [];
 displayedColumns: string[] = [
          "checkbox",
          "id",
         // "applicationNo",
          "applicantName",
         // "board",
          "lottery",
          "scheme",
          "tenement",
          "aceeptanceStartDate",
          "aceeptanceEndDate",
          "drawStatus",
        //  "action",
        
];

applicationDrawStatus: any[] = [
  { name: "DRAW WINNER", value: "DRAW_WINNER" },
  { name: "DRAW WAITLIST ACTIVATED ",value: "DRAW_WAITLIST_ACTIVATED" }
];

  constructor(
    private router: Router,
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController,
    private installmentConfigService: InstallmentConfigService,
    private extendAcceptanceService :ExtendAcceptanceService,
  ) { }

  ngOnInit() {
    this.loadData();

    this.form = new FormGroup({
      lotteryKey: new FormControl(null, Validators.required),
      schemeKey: new FormControl(null, Validators.required),
      isAllSelected: new FormControl(null, Validators.required),
      drawStatus: new FormControl(null),
      filterText: new FormControl(null, [Validators.required,Validators.minLength(3),
      ]),
    });
    this.form.controls["filterText"].setValue(null);
  }

  loadData() {
    this.isLoading = true;
      this.extendAcceptanceService.initExtendAcceptanceForm().subscribe(
      (data) => {
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.lotteryList = data.lotteries;
        } else {
          this.installmentConfigService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.installmentConfigService.errorToast(
          error?.error?.message || error?.error?.errorMessage
        );
        this.isLoading = false;
      }
    );
  }

  onSubmit() {
  
  }

  onCheckboxChange(row: TenementModal,event) {
    this.isButtonVisible=event.checked;
    console.log(" this.isButtonVisible",  this.isButtonVisible);

    if (row.isSelected) {
      this.isSubmitDisabled = false;
      // this.selectedElement = row;
      this.selectedElements.push(row);
      console.log("this.selectedElement", this.selectedElements);
    } else {
      // this.selectedElement = null;
      this.selectedElements = this.selectedElements.filter(
        (element) => element !== row
      );
    }
    this.isAnyCheckboxSelected = this.selectedElements.length > 0;
  }

  selectAll(event) {
    this.selectedElements = [];
    this.isButtonVisible=event.checked
  this.dataSource.data.forEach((element) => {
    element.isSelected = event.checked;
    if (element.isSelected) {
      this.selectedElements.push(element);
    }
  });

  this.isAllSelected = event.checked;
  this.isAnyCheckboxSelected = this.selectedElements.length > 0;
  console.log("this.isAllSelected", this.isAllSelected);
  console.log("this.selectedElements", this.selectedElements);
  }

  onSearch(){
    if (this.schemeKey > 0) {
      this.isLoading = true;
      this.extendAcceptanceService.getLotteryandSchemeData( this.currentPage,
        this.pageSize,this.lotteryKey,this.schemeKey,this.drawStatus,this.form.value.filterText).subscribe(
        (data) => {
          this.isLoading = false;
          // this.dataSource=data.content;
          this.dataSource = new MatTableDataSource(data.content);
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = data.totalElements;
          this.isLoading = false;
          this.isAnyCheckboxSelected = false;
        },
        (error) => {
          this.installmentConfigService.errorToast(
            error?.error?.message || error?.error?.errorMessage
          );
          this.isLoading = false;
        }
      );
    }
  }

  onSchemeChange(e: any) {
    console.log("++++++++++++++e?.key ",e?.key );
    this.schemeKey=e?.key ;
    this.onSearch();
  }

  resetFilter(){
    window.location.reload();

  }

  async openModal() {
        if (this.selectedElement) {
          const modal = await this.modalCtrl.create({
            component: ExtendedAcceptanceModalComponent,
           // cssClass: "master-modal-lg",
            componentProps: {
             //aceeptanceDate: this.selectedElement.accTenementStartDate,
              //surrenderDate:this.selectedElement.accTenementEndDate,
             data:this.selectedElements
            },
          });
          await modal.present();
          this.isSubmitDisabled = false;
          const { data } = await modal.onWillDismiss();
          if (data === "submit") {
           this.isButtonVisible=false
            // this.isLoadingAfterSave = true;
            this.onSearch();
          }
        } else {
          this.errorToast("Please Select a Checkbox.");
          this.isSubmitDisabled = false;

        }
   
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
  this.onSearch()
  }

  onLotteryChange(e: any) {
    this.lotteryKey=e.key
    if (e?.key > 0) {
      this.isLoading = true;
        this.extendAcceptanceService.initWithLottery(e.key).subscribe(
        (data) => {
          this.isLoading = false;
          if (data.status === "SUCCESS") {
            this.schemes = data.schemes;
           
           
          } else {
            this.installmentConfigService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.installmentConfigService.errorToast(
            error?.error?.message || error?.error?.errorMessage
          );
          this.isLoading = false;
        }
      );
    }
  }

  async successToast() {
    await this._snackBar.open(
      "Extend Acceptance details saved successfully.",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async warningToast() {
    await this._snackBar.open("", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }

  showDrawStatus(o1: any, o2: any) {
    if (o1 && o2 && o1 == o2) {
      return o1;
    } else {
      return "";
    }
  }

  onDrawStatusChange(value: any) {
    this.isSubmitDisabled = false;
    this.drawStatus = value;
    console.log("drawStatus++",this.drawStatus);
  }

  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
